
import React from "react";
import { Button } from "@/components/ui/button";
import { Eye, ExternalLink, Globe } from "lucide-react";

interface ExpertApplication {
  id: string;
  linkedin_url: string | null;
  status: 'pending' | 'under_review' | 'approved' | 'rejected';
}

interface TableRowActionsProps {
  application: ExpertApplication;
  onSelectApplication: (application: ExpertApplication) => void;
}

export default function TableRowActions({ application, onSelectApplication }: TableRowActionsProps) {
  return (
    <div className="flex items-center gap-2">
      <Button
        variant="ghost"
        size="sm"
        onClick={() => onSelectApplication(application)}
      >
        <Eye className="h-4 w-4" />
      </Button>
      {application.linkedin_url && (
        <Button
          variant="ghost"
          size="sm"
          onClick={() => window.open(application.linkedin_url!, '_blank')}
        >
          <ExternalLink className="h-4 w-4" />
        </Button>
      )}
      {application.status === 'approved' && (
        <Button
          variant="ghost"
          size="sm"
          onClick={() => window.open('/consultations', '_blank')}
          title="View on consultations page"
        >
          <Globe className="h-4 w-4" />
        </Button>
      )}
    </div>
  );
}
